import { useContext } from "react";
import { SearchSetValueContext } from "contexts/searchContext";

export default function useSetSearchValue() {
  const setSearchValue = useContext(SearchSetValueContext);

  const clearSearch = () => {
    setSearchValue("");
  };

  return {
    setSearchValue,
    clearSearch,
  };
}
